import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DynamicFormsService } from '../../services/dynamic-forms.service'


@Component({
    selector: 'app-grid-selector',
    templateUrl: './grid-selector.component.html',
    styleUrls: ['./grid-selector.component.css'],
    standalone: false
})
export class GridSelectorComponent implements OnInit {

  readonly oldObjectAvaliableColumns:columnsDef[];
  readonly oldObjectEnableColumns:columnsDef[];
  public availableColumns:columnsDef[] = [];
  public enableColumns:columnsDef[] = [];
  public availableSelected:Set<any> = new Set();
  public enabledSelected:Set<any> = new Set();
  public dynaServices:DynamicFormsService;


  constructor(@Inject(MAT_DIALOG_DATA) data,public dialogRef: MatDialogRef<any>, private snackBar: SnackbarService, private cd: ChangeDetectorRef  )  {

    this.dynaServices =  data.dynaServices;
    this.oldObjectAvaliableColumns = [...this.dynaServices.availableColumns];
    this.oldObjectEnableColumns = [...this.dynaServices.enabledColumns];

    this.enableColumns = this.dynaServices.enabledColumns;
    this.availableColumns = this.dynaServices.availableColumns;

  }

  ngOnInit() {

  }

  toggleAvailable(id:any, checked:boolean):void{
    checked ? this.availableSelected.add(id) : this.availableSelected.delete(id);
  }

  toggleEnabled(id:any, checked:boolean):void{
    checked ? this.enabledSelected.add(id) : this.enabledSelected.delete(id);
  }

  allAvailableChecked():boolean{
    return this.dynaServices.availableColumns.length > 0 && this.availableSelected.size == this.dynaServices.availableColumns.length;
  }

  allEnabledChecked():boolean{
    return this.dynaServices.enabledColumns.length > 0 && this.enabledSelected.size == this.dynaServices.enabledColumns.length;
  }

  toggleAllAvailable(checked:boolean):void{
    this.availableSelected.clear();
    if ( checked ){
      this.dynaServices.availableColumns.forEach(x=> this.availableSelected.add(x['IDCOLUMN']));
    }
  }

  toggleAllEnabled(checked:boolean):void{
    this.enabledSelected.clear();
    if ( checked ){
      this.dynaServices.enabledColumns.forEach(x=> this.enabledSelected.add(x['IDCOLUMN']));
    }
  }

public sendColumns( type:String) :void{

    if ( type == "a"){
      this.availableSelected.forEach(value => {
          this.dynaServices.refreshForm(this.availableColumns.filter(x=> x['IDCOLUMN'] == value)[0]);
          this.dynaServices.enabledColumns.push( this.availableColumns.filter(x=> x['IDCOLUMN'] == value)[0]) ;
          this.availableColumns = this.availableColumns.filter(x=> x['IDCOLUMN'] != value);
          this.dynaServices.availableColumns = this.availableColumns.sort();
      });
      this.availableSelected.clear();
    }else{
      this.enabledSelected.forEach(value => {
          this.dynaServices.availableColumns.push(this.enableColumns.filter(x=> x['IDCOLUMN'] == value)[0]);
          this.enableColumns = this.enableColumns.filter(x=> x['IDCOLUMN'] != value);
          this.dynaServices.enabledColumns = this.enableColumns.sort();
      });
      this.enabledSelected.clear();
    }
  }

 public confirm():void{
    this.dialogRef.close([this.enableColumns,this.availableColumns]);
 }

 public closeGrid():void{
    this.dialogRef.close();
    this.dynaServices.enabledColumns = this.oldObjectEnableColumns;
    this.dynaServices.availableColumns = this.oldObjectAvaliableColumns;
    this.dynaServices.cd.detectChanges();
 }

 public orderColumn(type:String ):void{
    if ( this.enabledSelected.size == 0 ){
      return;
    }

    if ( this.enabledSelected.size > 1 ){
      this.snackBar.showError("Selecionar apenas uma coluna para mudança de ordem.");
      return;
    }

    let selectedValue = this.enabledSelected.values().next().value;
    let index:number = this.enableColumns.findIndex(x=> x['IDCOLUMN'] == selectedValue);

    if ( type == 'u'){
      if (index === 0) {
        return;
      }
      this.enableColumns.splice(index - 1, 0,this.enableColumns.splice(index,1)[0]);
    }else{
      if (index === this.enableColumns.length - 1) {
        return;
      }
       this.enableColumns.splice(index + 1, 0,this.enableColumns.splice(index,1)[0]);
    }

 }
}
